import type { BoxProps } from '@mui/material';
import { Box } from '@mui/material';
import type { FormikProps } from 'formik';
import type { Position } from 'geojson';
import type { PropsWithChildren } from 'react';
import { CenterMiniMap } from '../map/center-mini-map/controller.js';
import { DraggableMarkerLayer } from '../map/layers/draggable-marker.js';
import { MapStyles } from '../map/map-styles.js';

type Props<ID, T> = BoxProps & {
  id: ID;
  formik: FormikProps<T>;
  height?: number | string;
};

export function FormikLocationMapField<
  ID extends string,
  T extends { [key in ID]?: Position | null },
>(props: PropsWithChildren<Props<ID, T>>): JSX.Element {
  const { formik, id, ...boxProps } = props;

  // TODO no location

  return (
    <Box
      {...boxProps}
      sx={(theme) => ({
        borderRadius: `${theme.shape.borderRadius}px`,
        overflow: 'clip',
      })}
    >
      <CenterMiniMap
        center={formik.values[id]}
        height={boxProps.height ?? 120}
        mapStyle={MapStyles.DARK}
        width="100%"
      >
        {props.children}
        <DraggableMarkerLayer
          onPointChange={(point) => {
            formik.setFieldValue(id, point);
          }}
          point={formik.values[id]}
        />
      </CenterMiniMap>
    </Box>
  );
}
